@if (layer) {
  <jmkw-flight-level-select
    [layer]="windsAloftLayer"
    (selectionChanged)="updateSelectedFlightLevel($event)"
  ></jmkw-flight-level-select>
}
@if (windsAloftLayer) {
  <jmkw-time-span-select
    [layer]="windsAloftLayer"
    (selectionChanged)="updateSelectedTime($event)"
  ></jmkw-time-span-select>
}
<!-- <label
><input
[(ngModel)]="windsAloftIconOverlap"
type="checkbox"
/>
<p class="checkbox">WA Default</p></label
> -->
<temps-winds-aloft-legend-svg></temps-winds-aloft-legend-svg>

<ng-template #controlBarContent>
  <label class="checkbox-container">
    <input [(ngModel)]="windsAloftIconOverlap" type="checkbox" />
    <span class="checkbox-text">WA Default</span>
  </label>
</ng-template>
